/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The overall status of the response generation. 'completed' means successfully finished, 'failed' means error occurred, 'in_progress' means currently processing, 'cancelled' means user-cancelled, 'queued' means waiting to start, 'incomplete' means partial completion.
 */
export const ResponseStatus = {
  Completed: "completed",
  Failed: "failed",
  InProgress: "in_progress",
  Cancelled: "cancelled",
  Queued: "queued",
  Incomplete: "incomplete",
} as const;
/**
 * The overall status of the response generation. 'completed' means successfully finished, 'failed' means error occurred, 'in_progress' means currently processing, 'cancelled' means user-cancelled, 'queued' means waiting to start, 'incomplete' means partial completion.
 */
export type ResponseStatus = ClosedEnum<typeof ResponseStatus>;

/** @internal */
export const ResponseStatus$inboundSchema: z.ZodNativeEnum<
  typeof ResponseStatus
> = z.nativeEnum(ResponseStatus);
/** @internal */
export const ResponseStatus$outboundSchema: z.ZodNativeEnum<
  typeof ResponseStatus
> = ResponseStatus$inboundSchema;
